/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, Snackbar } from '@material-ui/core';

import backgroundImg from 'images/bg/desktop/background.png';
import backgroundImgMobile from 'images/bg/mobile/bg.png';
import topRightImg from 'images/bg/desktop/grafismo-direito-branco.png';
import bottomRightImg from 'images/bg/desktop/grafismo-lado-direito-inferior.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    minHeight: '100%',
    overflowY: 'auto',
    backgroundColor: theme.palette.neutral,
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${backgroundImg})`,
    position: 'relative',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${backgroundImgMobile})`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '10%',
    paddingRight: '8%',
    paddingTop: '13%',
    zIndex: '99',
    [theme.breakpoints.up('md')]: {
      paddingTop: '13%',
    },
    [theme.breakpoints.up('lg')]: {
      paddingTop: '1%',
    }
  },
  bottomRightImg: {
    top: '73.5%',
    left: '50.5%',
    height: 'auto',
    position: 'absolute',
    width: '50%',
    [theme.breakpoints.up('lg')]: {
      width: '20%',
      top: '51%',
      left: '80.5%',
    },
  },
  topRightImg: {
    left: '63%',
    height: 'auto',
    position: 'absolute',
    width: '38%',
    [theme.breakpoints.up('lg')]: {
      left: '81%',
      width: '20%',
    },
  },
}));

function Layout5({ children }) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const snack = useSelector((state) => state.snackbar);

  const closeSnackbar = () => {
    dispatch({ type: 'CLOSE_SNACKBAR' });
  }

  return (
    <React.Fragment>
      <div className={classes.root}>
        <img alt="" className={classes.topRightImg} src={topRightImg} />
        <img alt="" className={classes.bottomRightImg} src={bottomRightImg} />
        <Grid className={classes.content} item style={{ 'width': '100%' }} xs={12}>
          {children}
        </Grid>
      </div>
      <Snackbar
        autoHideDuration={6000}
        message={snack.message}
        onClose={closeSnackbar}
        open={snack.show}
      />
    </React.Fragment>
  );
}

Layout5.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Layout5;
